// Data that can be returned via responses to user messages.

// Messages with this category have a JSON stringified UserMessageResponseData object as their content.
export const USER_MESSAGE_RESPONSE_DATA_CATEGORY = 'UserMessageResponseData';

export interface Interaction {
  kind: "Click" | "InputText";

  // Element to interact with. All elements must have a data-testid attribute.
  dataTestId: string;

  // InputText: The text to enter into the input identified by the selector.
  text?: string;
}

// Contents of an InteractionInstructions message.
export interface InteractionInstructions {
  // Interactions to perform in sequence.
  interactions: Interaction[];

  // Set if these interactions will completely resolve the request.
  // If not set, after performing all interactions the client might send another
  // message asking for the next interactions.
  complete?: boolean;
}

export interface UserMessageResponseData {
  // Names of any features scheduled as a result of the user's message.
  featureNames: string[];

  // Any instructions for how to interact with the app.
  interactionInstructions?: InteractionInstructions;
}
